import React, { useMemo } from "react";
import { Box } from "@mui/system";
import { EmissionsAllocationOverviewRequestBody } from "api";
import { useEmissionAllocationOverviewById } from "hooks";
import { CustomMaterialTable, Loading } from "components";
import { getEmissionsAllocationColumns } from "./components";

export const EmissionsAllocationTable = ({ query }: { query: EmissionsAllocationOverviewRequestBody }) => {
    const { data, isFetching } = useEmissionAllocationOverviewById(query);
    const columns = useMemo(
        () => getEmissionsAllocationColumns(),
        []
    );
    if (isFetching) return <Loading />

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, pt: 2, width: "100%" }}>
            <CustomMaterialTable
                containerSx={{
                    height: "calc(100vh - 493px)",
                    minHeight: "200px",
                    width: "100%",
                    "& thead tr th:first-of-type > div": {
                        justifyContent: "center",
                    }
                }}
                columns={columns}
                data={data || []}
                enableColumnResizing
                enableDensityToggle={false}
                initialState={{ density: "compact" }}
                enablePagination={false}
                enableGrouping
            />
        </Box>
    )
}